import { messages } from '@/js/app-bridge/messages'
import { loadScript } from '@/js/helpers/scripts'
import type { IRogue } from '@/js/services/RogueTypes'

type AdobePreviewOpts = {
  embedMode: string,
  defaultViewMode?: string,
  showDownloadPDF?: boolean,
  div?: string

  [key: string]: string | boolean | undefined;
}

type AdobeViewer = {
  previewFile: (
    config: {
      content: { location: { url: string } },
      metaData: {fileName: string}
    },
    opts: AdobePreviewOpts) => void
}

let loadPromise: Promise<void>

function loadAdobeScript(rogue: IRogue):Promise<void> {
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      document.addEventListener('adobe_dc_view_sdk.ready', () => resolve())

      loadScript('https://documentservices.adobe.com/view-sdk/viewer.js', rogue).catch(err => {
        rogue.log.warn('Error loading Adobe script', err)
        reject(err)
      })
    })
  }

  return loadPromise
}

export async function viewProgram(
  rogue: IRogue,
  url: string,
  program: { name: string, thumbnail?: { src: string } },
  settings: AdobePreviewOpts = { embedMode: 'LIGHT_BOX', defaultViewMode: 'FIT_WIDTH', showDownloadPDF: false }
) {
  if (rogue.appContext) {
    if (rogue.isApp('3.1.1')) {
      rogue.emitToApp(messages.OPEN_DOCUMENT, {
        url,
        title         : program.name,
        thumbnail     : program.thumbnail?.src,
        fileExtension : 'pdf',
        disallowShare : true,
        allowOffline  : true,
      })
    } else {
      rogue.emitToApp(messages.OPEN_IN_BROWSER, { url: window.location.pathname })
    }
  } else if (/iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent))) {
    // iOS Safari downloads the entire PDF before rendering in the Adobe viewer, which causes
    // large files (~50MB+) to exhaust the tab memory limit and silently fail.
    // Open directly instead — iOS handles PDFs natively and streams them efficiently.
    window.open(url, '_blank')
  } else {
    await loadAdobeScript(rogue)
    // @ts-ignore
    const config: {clientId:string, divId?:string} = { clientId: rogue.keys.adobePdfEmbed }

    if (settings.div) {
      config.divId = settings.div
    }
    // @ts-ignore
    const viewer = new window.AdobeDC.View(config) as AdobeViewer
    viewer.previewFile({
      content  : { location: { url } },
      metaData : { fileName: `${program.name}.pdf` },
    }, settings)
  }
}
